import { ActionIcon, Group, Tooltip } from '@mantine/core'
import { IconPlugConnected, IconReload, IconTrash } from '@tabler/icons-react'
import { ReactNode } from 'react'
import { FormattedMessage } from 'react-intl'

type ActionButtonProps = {
  tooltip: ReactNode
  icon: ReactNode
  color?: string
  loading?: boolean
  onClick: () => void
}

const ActionButton = ({
  tooltip,
  icon,
  color,
  loading,
  onClick
}: ActionButtonProps) => {
  return (
    <Tooltip label={tooltip}>
      <ActionIcon
        variant="outline"
        size="md"
        radius="sm"
        color={color}
        loading={loading}
        onClick={onClick}
      >
        {icon}
      </ActionIcon>
    </Tooltip>
  )
}

type AiBridgeListActionsProps = {
  canManageAiBridge: boolean
  canDeleteAiBridge: boolean
  isTesting?: boolean
  onTestAiBridge: () => void
  onRestartAiBridge: () => void
  onDeleteAiBridge: () => void
}

export const AiBridgeListActions = ({
  canManageAiBridge,
  canDeleteAiBridge,
  isTesting,
  onTestAiBridge,
  onRestartAiBridge,
  onDeleteAiBridge
}: AiBridgeListActionsProps) => {
  return (
    <Group wrap="nowrap" gap={8} justify="end">
      {canManageAiBridge && (
        <ActionButton
          tooltip={<FormattedMessage id="aiBridge.list.buttons.test.tooltip" />}
          icon={<IconPlugConnected style={{ width: '70%', height: '70%' }} />}
          color="blue"
          loading={isTesting}
          onClick={onTestAiBridge}
        />
      )}

      {canManageAiBridge && (
        <ActionButton
          tooltip={
            <FormattedMessage id="aiBridge.list.buttons.restart.tooltip" />
          }
          icon={<IconReload style={{ width: '70%', height: '70%' }} />}
          color="orange"
          onClick={onRestartAiBridge}
        />
      )}

      {canDeleteAiBridge && (
        <ActionButton
          tooltip={
            <FormattedMessage id="aiBridge.list.buttons.delete.tooltip" />
          }
          icon={<IconTrash style={{ width: '70%', height: '70%' }} />}
          color="red"
          onClick={onDeleteAiBridge}
        />
      )}
    </Group>
  )
}
